import { useState } from "react";
import Card from "@/components/base/Card";
import Button from "@/components/base/Button";
import Badge from "@/components/base/Badge";
import { downloadMockPDF } from "@/utils/reports";

export default function DirectorReportePsicologiaPage() {
  const [generando, setGenerando] = useState(false);
  const [reports, setReports] = useState(() => {
    const saved = localStorage.getItem("reports_psicologia");
    if (saved) {
      try { return JSON.parse(saved); } catch (e) {}
    }
    return [
      {
        nombre: "Reporte_Atenciones_Psicologicas_Q1.pdf",
        fecha: "2026-06-05 16:30",
        tamano: "1.7 MB",
        creador: "Daniela Paredes",
        tipo: "Atenciones"
      }
    ];
  });

  const handleGenerate = () => {
    setGenerando(true);
    setTimeout(() => {
      const nuevo = {
        nombre: "Reporte_Psicologia_" + new Date().toISOString().slice(0,10) + ".pdf",
        fecha: new Date().toISOString().slice(0,10) + " " + new Date().toTimeString().slice(0,5),
        tamano: "2.4 MB",
        creador: "Sistema Ezer",
        tipo: "Atenciones"
      };
      const updated = [nuevo, ...reports];
      setReports(updated);
      localStorage.setItem("reports_psicologia", JSON.stringify(updated));
      setGenerando(false);
    }, 2000);
  };

  return (
    <div className="p-4 md:p-6 space-y-5 animate-fade-in-up">
      <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
        <div>
          <h1 className="text-xl md:text-2xl font-bold text-foreground-950">Reporte Psicosocial y Psicoterapéutico</h1>
          <p className="text-sm text-foreground-500 mt-0.5">Reportes consolidados (no confidenciales) sobre cantidad de atenciones, coberturas y derivaciones externas.</p>
        </div>
        <Button onClick={handleGenerate} disabled={generando} className="bg-primary-500 text-white hover:bg-primary-600 cursor-pointer">
          {generando ? (
            <>
              <i className="ri-loader-4-line animate-spin mr-1.5" /> Generando...
            </>
          ) : (
            <>
              <i className="ri-file-chart-line mr-1.5" /> Generar Nuevo Reporte
            </>
          )}
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-2">
          <Card padding="none">
            <div className="p-4 border-b border-background-150 flex items-center justify-between">
              <h3 className="font-bold text-foreground-900 text-sm">Historial de Reportes Generados</h3>
              <Badge variant="neutral">{reports.length} Documentos</Badge>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200 bg-background-50/50">
                    <th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase">Documento</th>
                    <th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase">Fecha</th>
                    <th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase">Tamaño</th>
                    <th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase">Generado Por</th>
                    <th className="text-right py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {reports.map((rep, idx) => (
                    <tr key={idx} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                      <td className="py-3 px-4">
                        <div className="flex items-center gap-2">
                          <i className="ri-file-pdf-fill text-red-500 text-lg" />
                          <span className="font-medium text-foreground-800 text-xs truncate max-w-[200px]">{rep.nombre}</span>
                        </div>
                      </td>
                      <td className="py-3 px-4 text-foreground-500 text-2xs whitespace-nowrap">{rep.fecha}</td>
                      <td className="py-3 px-4 text-foreground-500 text-2xs whitespace-nowrap">{rep.tamano}</td>
                      <td className="py-3 px-4 text-foreground-600 text-xs whitespace-nowrap">{rep.creador}</td>
                      <td className="py-3 px-4 text-right">
                        <button 
                          onClick={() => downloadMockPDF(rep.nombre)}
                          className="px-2.5 py-1 text-xs border border-background-250 hover:bg-background-50 text-foreground-600 rounded-lg cursor-pointer transition-colors"
                        >
                          <i className="ri-download-line mr-1" /> Bajar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
        <div className="space-y-4">
          <Card className="space-y-3">
            <h3 className="font-bold text-foreground-900 text-sm">Resumen de Parámetros</h3>
            <p className="text-xs text-foreground-500 leading-relaxed">Los reportes consolidados incluyen automáticamente la información acumulada de la institución correspondiente al período activo.</p>
            <div className="space-y-2 pt-1 border-t border-background-100">
              <div className="flex justify-between text-xs">
                <span className="text-foreground-500">Formato:</span>
                <span className="font-semibold text-foreground-800">PDF (.pdf)</span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-foreground-500">Período:</span>
                <span className="font-semibold text-foreground-800">Año Escolar 2026</span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-foreground-500">Filtro Legal:</span>
                <span className="font-semibold text-foreground-800">Ley 20.536 Incluida</span>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
